import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DateInputDialogComponent } from 'src/app/components/shared/date-input-dialog/date-input-dialog.component';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateInputDialogService {

  constructor(private dialog: MatDialog) { }

  /**
   * Abre un diálogo modal para capturar una fecha en formato YYYYMMDD
   * @param title Título del modal (opcional)
   * @param message Mensaje a mostrar (opcional)
   * @param placeholder Placeholder del input (opcional)
   * @param operationNumber Número de operación del registro actual (opcional)
   * @param identifierNumber Número de documento del registro actual (opcional)
   * @returns Promise<string | null> - La fecha ingresada o null si se cancela
   */
  public promptDate(
    title: string = 'Ingrese fecha de inicio',
    message: string = 'Ingrese la fecha de inicio en formato YYYYMMDD:',
    placeholder: string = 'YYYYMMDD',
    operationNumber?: string,
    identifierNumber?: string
  ): Promise<string | null> {
    const dialogRef = this.dialog.open(DateInputDialogComponent, {
      width: '600px',
      disableClose: true,
      data: {
        title: title,
        message: message,
        placeholder: placeholder,
        btnOkText: 'Aceptar',
        btnCancelText: 'Cancelar',
        operationNumber: operationNumber,
        identifierNumber: identifierNumber
      }
    });

    return firstValueFrom(dialogRef.afterClosed());
  }

}
